import React, { useContext, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import UserContext from '../user/UserContext';
import axios from 'axios';
import AuthContext from '../authentication/AuthContext';

// Not named Nav to avoid accidental conflicts with Bootstrap
export default function AocNav() {
    const { userDetails } = useContext(UserContext);
    const cas = useContext(AuthContext);
    const location = useLocation();

    const [newPresells, setNewPresells] = useState(0);
    const [newAllocations, setNewAllocations] = useState(0);
    const [newWebDeals, setNewWebDeals] = useState(0);

    const webDealsControlGroupName = 'Web Deals Control Group';
    const connectOnlineControlGroupName = 'Connect Online Control Group';

    useEffect(() => {
        const countPresells = () => {
            axios
                .get(window.CONFIG['ws.activoc-presell-public.presells.active'].replace('{filterType}', 'presells'), {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json',
                        'x-franchise-code': userDetails.currentFranchise.code
                    },
                    params: {
                        purpose: 'count'
                    }
                })
                .then(response => {
                    setNewPresells(response.data.filter(p => !p.hasRetailerInteractions).length);
                }).catch(error => {
                console.error(error);
            });
        };

        const countAllocations = () => {
            axios
                .get(window.CONFIG['ws.activoc-presell-public.presells.active'].replace('{filterType}', 'allocations'), {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json',
                        'x-franchise-code': userDetails.currentFranchise.code
                    },
                    params: {
                        purpose: 'count'
                    }
                })
                .then(response => {
                    setNewAllocations(response.data.filter(p => !p.hasRetailerInteractions).length);
                }).catch(error => {
                console.error(error);
            });
        };

        if (!!userDetails.currentFranchise) {
            countPresells();
            countAllocations();
        }
    }, [cas, userDetails, location]);

    useEffect(() => {
        if (!!userDetails.currentFranchise) {
            axios
                .get(window.CONFIG['ws.activoc-web-deals-public.get.new.count'], {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    setNewWebDeals(response.data.dealCount);
                });
        }
    }, [cas, userDetails, location]);

    function inChristmasWindow() {
        const today = new Date();
        const startDate = new Date(window.CONFIG['activoc.christmas.schedules.start']);
        startDate.setDate(startDate.getDate() - 7);
        const endDate = new Date(window.CONFIG['activoc.christmas.schedules.start']);
        endDate.setDate(endDate.getDate() + parseInt(window.CONFIG['activoc.christmas.schedules.weeks']) * 7);

        return startDate <= today && today <= endDate;
    }

    return (
        <nav id={'primary-nav'}>
            <div className={'content flex'}>
                <ul className={'primary-nav-list'}>
                    <li>
                        <NavLink exact to={'/'} activeClassName={'active'} title={'My Orders'}>
                            My Orders
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={'/allocations'}
                            activeClassName={'active'}
                            data-testid={'allocations-tab-link'}
                        >
                            <span className={'nav-notification-container'}>
                                {newAllocations > 0 && (
                                    <span className={'nav-notification'} data-testid={'allocation-count'}>
                                        {newAllocations}
                                    </span>
                                )}
                                My Allocations
                            </span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={'/presells'}
                            activeClassName={'active'}
                            data-testid={'presells-tab-link'}
                        >
                            <span className={'nav-notification-container'}>
                                {newPresells > 0 && (
                                    <span className={'nav-notification'} data-testid={'presell-count'}>
                                        {newPresells}
                                    </span>
                                )}
                                My Presells
                            </span>
                        </NavLink>
                    </li>
                    {userDetails?.currentFranchise?.controlGroups.includes(webDealsControlGroupName) && (
                        <li>
                            <NavLink to={'/web-deals'} activeClassName={'active'} title={'My Web Deals'}>
                                <span className={'nav-notification-container'}>
                                    {newWebDeals > 0 && (
                                        <span className={'nav-notification'} data-testid={'web-deal-count'}>
                                            {newWebDeals}
                                        </span>
                                    )}
                                    My Web Deals
                                </span>
                            </NavLink>
                        </li>
                    )}
                    <li>
                        <NavLink to={'/product-range'} activeClassName={'active'} title={'Product Range'}>
                            Product Range
                        </NavLink>
                    </li>
                    {inChristmasWindow() && (
                        <li>
                            <NavLink
                                to={'/christmas-schedule'}
                                activeClassName={'active'}
                                title={'My Christmas Schedule'}
                            >
                                My Christmas Schedule
                            </NavLink>
                        </li>
                    )}
                    <li>
                        <NavLink to={{ pathname: window.CONFIG['activei.web.url']}} activeClassName={'active'} title={'My Invoices'} target={'_blank'}>
                            My Invoices
                        </NavLink>
                    </li>
                </ul>
                <ul className={'external-links-nav-list'}>
                    <li>
                        <NavLink
                            to={'/trading-agreement'}
                            activeClassName={'active'}
                            title={'Trading Agreement'}
                        >
                            Trading Agreement
                        </NavLink>
                    </li>
                </ul>
            </div>
        </nav>
    );
}
